"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAnimationLayers = useAnimationLayers;
const React = __importStar(require("react"));
const animationLayerSlots_1 = require("./animationLayerSlots");
const animations_1 = require("./animations");
function useAnimationLayers(pieceId, animationEventStore) {
    const attackBasicStyles = (0, animations_1.useAttackBasicStyles)();
    const receiveHitStyles = (0, animations_1.useReceiveHitStyles)();
    const dyingStyles = (0, animations_1.useDyingStyles)();
    const [layers, setLayers] = React.useState(animationLayerSlots_1.EMPTY_LAYER_SLOTS);
    const [isDying, setIsDying] = React.useState(false);
    const processEvents = React.useCallback((events) => {
        const newLayers = [];
        for (const event of events) {
            switch (event.type) {
                case "piece_attack": {
                    if (!event.ranged) {
                        newLayers.push((0, animations_1.createAttackBasicLayer)(event, attackBasicStyles.attackBasic));
                    }
                    break;
                }
                case "piece_hit": {
                    newLayers.push((0, animations_1.createReceiveHitLayer)(event, receiveHitStyles.receiveHit));
                    break;
                }
                case "piece_dying": {
                    setIsDying(true);
                    break;
                }
                default: {
                    console.warn("Unhandled animation event type:", event);
                    break;
                }
            }
        }
        if (newLayers.length > 0) {
            setLayers((prev) => {
                let next = prev;
                for (const layer of newLayers) {
                    next = (0, animationLayerSlots_1.assignLayer)(next, layer);
                }
                return next;
            });
        }
    }, [attackBasicStyles.attackBasic, receiveHitStyles.receiveHit]);
    // subscribe to the animation event store
    React.useEffect(() => {
        const unsubscribe = animationEventStore.subscribe(() => {
            const events = animationEventStore.consumeEventsForPiece(pieceId);
            if (events.length > 0) {
                processEvents(events);
            }
        });
        return unsubscribe;
    }, [pieceId, animationEventStore, processEvents]);
    const onLayerAnimationEnd = React.useCallback((name) => {
        setLayers((prev) => (0, animationLayerSlots_1.removeLayer)(prev, name));
    }, []);
    return {
        layers,
        isDying,
        dyingClassName: dyingStyles.dying,
        onLayerAnimationEnd,
    };
}
